import React, { Component } from 'react';

//componentes
import Primaria from './primaria'

class Index extends Component {

    render(){
        return(
            <div>
                <Primaria />
            </div>
        );
    }

}
export default Index;